export const TemplateType = {
  WEEK: "WEEK",
  SESSION: "SESSION",
  EXERCISE: "EXERCISE",
} as const
export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType]

export const TemplateTypeFilter = {
  ALL: "ALL",
  [TemplateType.WEEK]: TemplateType.WEEK,
  [TemplateType.SESSION]: TemplateType.SESSION,
  [TemplateType.EXERCISE]: TemplateType.EXERCISE,
} as const
export type TemplateTypeFilter = (typeof TemplateTypeFilter)[keyof typeof TemplateTypeFilter]
